import CustomCss from './CustomCss'

export * from './CustomCss'
export default CustomCss
